import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import moment from "moment";
import { InputDate, InputText, Form, Button, Spin } from "common/elements";
import { getOne, insertNewRecord, updateRecordById } from "services/holiday";
import { Util } from "common/util";

const util = new Util();
export default class FormInsertOrUpdate extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    disabled: false,
    loading: false,
    loadingFormData: false,
  };

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              name: formData.name,
              nameKH: formData.nameKH,
              type: formData.type,
              rate: formData.rate,
              start: moment(formData?.start),
              end: moment(formData?.end),
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
    });
  };

  onFinish = (values) => {
    values["start"] = util.formatDateForMYSQL(values["start"]);
    values["end"] = util.formatDateForMYSQL(values["end"]);
    this.setState({ loading: true, disabled: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const { isModalVisible, id, loading, loadingFormData, disabled } =
      this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_holiday") : t("text_new_holiday")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            key={id}
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_name")}
              requiredMessage={t("text_please_input_name")}
            />

            <InputText
              name="nameKH"
              label={t("text_nameKH")}
              placeholder={t("text_nameKH")}
            />
            <Form.Item
              name="start"
              label={t("text_start")}
              rules={[
                { required: true, message: t("text_please_select_start_date") },
              ]}
              className="datepicker"
            >
              <InputDate
                name="start"
                placeholder={t("text_start")}
                initialValue={moment()}
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="end"
              label={t("text_end")}
              rules={[
                { required: true, message: t("text_please_select_end_date") },
              ]}
              className="datepicker"
            >
              <InputDate
                name="end"
                placeholder={t("text_end")}
                initialValue={moment()}
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
